module.exports = __webpack_public_path__ + "img/i-game-credits-coin.1d5720f5.svg";